import {createContext, useContext} from "react";
import {Country} from "types/global";

export const CountriesContext = createContext<Country[] | null>(null);

export const useCountries = (): Country[] => {
  const context = useContext(CountriesContext);
  if (!context) {
    throw new Error("useCountries must be used within a CountriesProvider");
  }
  return context;
};
